import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationServiceOnboardPostBody,
  IConfigurationServiceOnboardResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useCurlLogger } from "../../useCurlLogger";

type InventoryTaxCreateAPIResponse = { status: boolean; message: string; subServiceId?: string | null };

AxiosCurlirize(axios, () => {});
export const useConfigurationServiceUpdateAPI = () => {
  const [updatedServiceId, setUpdatedServiceId] = useState<string>("");
  const configuration = useConfiguration();

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (servieData: IConfigurationServiceOnboardPostBody, section?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!servieData) {
          return;
        }
        const endpoint = section
          ? `${CONFIGURATION_APIS?.SERVICE_UPDATE?.baseURL}?section=${section}`
          : `${CONFIGURATION_APIS?.SERVICE_UPDATE?.baseURL}`;
        const response: InventoryTaxCreateAPIResponse = await axios
          .put(endpoint, servieData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationServiceOnboardResponse>) => {
            if (res.data.status) {
              const responseData = (res.data as any)?.data || {};
              const serviceId = responseData?.service_id ?? null;
              const subServiceId =
                responseData?.sub_service_id ??
                responseData?.subServiceId ??
                responseData?.service_details?.sub_service_id ??
                responseData?.sub_service_details?.sub_service_id ??
                null;
              return { status: true, message: serviceId, subServiceId };
            } else {
              toast.error("Error while updating the service.");
              return { status: false, message: null, subServiceId: null };
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            return { status: false, message: null, subServiceId: null };
          });
        return response;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching service details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { updatedServiceId, execute };
};
